import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: { display: 'flex', alignItems: 'center' } }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "答题人：", -1)
const _hoisted_4 = {
  key: 0,
  class: "action",
  style: {"margin-left":"50px"}
}

import dayjs from "dayjs";
import router from "@/router";
import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { useLoginUserStore } from "@/store/userStore";
import {
  deleteUserAnswerUsingPost,
  listMyUserAnswerVoByPageUsingPost,
} from "@/api/userAnswerController";
import {
  APP_SCORING_STRATEGY_ENUM,
  APP_SCORING_STRATEGY_MAP,
  APP_TYPE_ENUM,
  APP_TYPE_MAP,
} from "../../constant/appEnum";

interface Props {
  userId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerList',
  props: {
    userId: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;
//查询参数
const searchParams = ref<API.UserAnswerQueryRequest>({
  current: 1,
  pageSize: 10,
  userId: props.userId,
  sortField: "createTime",
  sortOrder: "descend",
});
//总值
const total = ref<number>(0);
//是否显示加载
const loading = ref(true);
// 答案列表
const dataList = ref<API.UserAnswerVO[]>([]);
//搜索关键词
const searchText = ref<string>("");
//总值
const loginUser = ref<API.UserVO>(useLoginUserStore().loginUser);
const isMy = ref(props.userId == loginUser.value.id);
/**
 * 搜索
 */
const search = async () => {
  if (searchText.value == "") {
    return;
  }
};
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listMyUserAnswerVoByPageUsingPost(searchParams.value);
  if (response.data.code === 0 && response.data.data) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 点击菜单项
 * @param id
 */
const onClickMenuItem = async (url: string) => {
  router.push(url);
};

/**
 * 删除答案
 */
const remove = async (id: number) => {
  const response = await deleteUserAnswerUsingPost({ id: id });
  if (response.data.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败，" + response.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  if (searchParams.value) {
    loadData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_icon_delete = _resolveComponent("icon-delete")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"margin":"0 0 10px auto"},
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "appType",
          label: "应用类型："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: searchParams.value.appType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.appType) = $event)),
              placeholder: "请输入...",
              "allow-clear": "",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  value: _unref(APP_TYPE_ENUM).SCORE
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)["0"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(APP_TYPE_ENUM).TEST
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)["1"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "scoringStrategy",
          label: "评分策略："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: searchParams.value.scoringStrategy,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.scoringStrategy) = $event)),
              placeholder: "请输入...",
              "allow-clear": "",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  value: _unref(APP_SCORING_STRATEGY_ENUM).CUSTOM
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)["0"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(APP_SCORING_STRATEGY_ENUM).AI
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)["1"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "resultName",
          label: "结果名称："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.resultName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.resultName) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "resultDesc",
          label: "结果描述："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.resultDesc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.resultDesc) = $event)),
              placeholder: "请输入..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_list, {
      bordered: false,
      data: dataList.value,
      "pagination-props": {
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      stripe: true,
      onPageChange: onPageChange,
      loading: loading.value
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, { "action-layout": "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              bordered: false,
              onClick: ($event: any) => (onClickMenuItem('/answer/result/' + item.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      span: 14,
                      class: "contentWrapper",
                      style: {"margin-left":"50px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(item.resultName), 1),
                        _createElementVNode("p", null, "结果描述：" + _toDisplayString(item.resultDesc), 1),
                        (item.appType == _unref(APP_TYPE_ENUM).SCORE)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " 结果得分：" + _toDisplayString(item.resultScore), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, "我的选择：" + _toDisplayString(item.choices), 1),
                        _createElementVNode("p", null, "应用类型：" + _toDisplayString(_unref(APP_TYPE_MAP)[item.appType]), 1),
                        _createElementVNode("p", null, " 评分策略：" + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[item.scoringStrategy]), 1),
                        _createElementVNode("div", _hoisted_2, [
                          _hoisted_3,
                          _createVNode(_component_a_avatar, {
                            size: 24,
                            style: { marginRight: '8px' },
                            "image-url": item.user?.userAvatar
                          }, null, 8, ["image-url"]),
                          _createVNode(_component_a_typography_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.user?.userName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("p", null, " 答题时间：" + _toDisplayString(_unref(dayjs)(item.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_image, {
                          width: "300",
                          style: {"margin":"50px"},
                          src: item?.resultPicture
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_popconfirm, {
                  content: "你确定要删除吗?",
                  onOk: ($event: any) => (remove(item.id)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    (isMy.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createVNode(_component_icon_delete)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["onOk"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination-props", "loading"])
  ], 64))
}
}

})